<template>
    <b-form-group :label="label" label-for="year-to-date">
        <Select
            id="year-to-date"
            :state="state"
            :selected="value"
            :options="yearToDateOptions"
            @changeValue="$emit('update:value', $event)"
            aria-describedby="year-to-date-feedback"
            :disabled="disabled"
        />
        <b-form-invalid-feedback id="year-to-date-feedback">
            <slot />
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
import i18n from '@/i18n'
import api from '@/services/api'
import { Select, mapperToOptions } from '@/views/components/selects'

export default {
    name: 'YearToDate',
    components: {
        Select,
    },
    props: ['value', 'state', 'disabled', 'label', 'moduleForm'],
    data() {
        return {
            yearToDateOptions: [],
        }
    },
    mounted() {
        api.get('/year-to-date', {
            params: {
                all: 1,
                ascending: 1,
                orderBy: 'title',
            },
        })
            .then(resp => {
                let {
                    data: { data },
                } = resp

                if (this.moduleForm == 'indicator') {
                    data = data.filter(ytd => ytd.title != 'manual')
                }
                const ytdWithTranslations = this.yearToDateWithTranslations(
                    data
                )
                this.yearToDateOptions = mapperToOptions(ytdWithTranslations)
                this.setDefaultOption(this.yearToDateOptions)
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$emit('ready', true)
            })
    },
    methods: {
        yearToDateWithTranslations(yearToDates) {
            return yearToDates.map(ytd => ({
                ...ytd,
                title: i18n.t(`yearToDate.${ytd.title}`),
            }))
        },
        setDefaultOption(ytdOptions) {
            let defaultOption = ytdOptions.find(ytd => ytd.isDefault)
            if (!defaultOption) {
                defaultOption = ytdOptions[0]
            }
            this.$emit('update:value', defaultOption)
        },
    },
}
</script>
